export const Worklets = {
  createRunOnJS: callback => callback,
};
